export default "__VITE_ASSET__Ca$C1jfH__"